import React from 'react';
import { motion } from 'framer-motion';
import PortfolioItem from './PortfolioItem';

// Import images from the local directory
import image1 from '../../Images/map_navigator.png';
import image2 from '../../Images/healthchain.jpeg';
import image3 from '../../Images/chrome_ext.jpeg';

const Portfolio = () => {
    // Sample portfolio data
    const portfolioItems = [
        {
            id: 1,
            image: image1,
            title: 'ROUTE ROVER',
            category: 'Software',
            description: 'Route Rover is a map navigator application using the A* algorithm.',
            githubLink: 'https://github.com/yourusername/route-rover',
        },
        {
            id: 2,
            image: image2,
            title: 'HEALTHCHAIN',
            category: 'Website',
            description: 'HealthChain is a blockchain-based health records management system.',
            githubLink: 'https://github.com/yourusername/healthchain',
        },
        {
            id: 3,
            image: image3,
            title: 'YuLu',
            category: 'Chrome Extension',
            description: 'YuLu is a Chrome extension that enhances productivity.',
            githubLink: 'https://github.com/yourusername/yulu',
        },
    ];

    // Animation variants
    const containerVariant = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2,
            },
        },
    };

    const itemVariant = {
        hidden: { opacity: 0, y: 20 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
    };

    return (
        <section className="bg-gray-900 py-12">
            <div className="container px-6 mx-auto">
                <motion.h1
                    className="text-3xl font-semibold text-center dark:text-white"
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                >
                    Projects
                </motion.h1>
                <motion.p
                    className="mt-4 text-center text-gray-600 dark:text-gray-400"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, delay: 0.2 }}
                >
                    Explore my portfolio of projects below.
                </motion.p>

                <motion.div
                    className="grid grid-cols-1 gap-8 mt-8 md:grid-cols-2 lg:grid-cols-3"
                    variants={containerVariant}
                    initial="hidden"
                    animate="visible"
                >
                    {portfolioItems.map((item) => (
                        <motion.div
                            key={item.id}
                            className="relative group overflow-hidden rounded-lg shadow-lg bg-gray-800"
                            variants={itemVariant}
                        >
                            {/* Background Image */}
                            <img
                                src={item.image}
                                alt={item.title}
                                className="w-full h-48 object-cover transition-transform duration-500 group-hover:scale-110"
                            />

                            {/* Hover Layer */}
                            <div className="absolute inset-0 flex flex-col items-center justify-center bg-black bg-opacity-70 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                <h3 className="text-lg font-semibold text-white mb-2">
                                    {item.title}
                                </h3>
                                <a
                                    href={item.githubLink}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="px-4 py-2 text-sm font-semibold text-white bg-blue-500 rounded-md hover:bg-blue-600"
                                >
                                    View on GitHub
                                </a>
                            </div>
                        </motion.div>
                    ))}
                </motion.div>
            </div>
        </section>
    );
};

export default Portfolio;